<table class="list" *ngIf="(items | async) as items">
  <tr class="list-item" *ngFor="let issue of items">
    <td style="padding-right: 0">
      <nb-user onlyPicture *ngIf="issue.assigneeName" [showInitials]="issue.assigneeAvatar == null" size="small"
               [name]="issue.assigneeName"
               [nbTooltip]="issue.assigneeName"
               [picture]="getImageUri(issue.assigneeAvatar)">
      </nb-user>
    </td>
    <td class="nw" style="white-space: nowrap">
      <nb-icon [icon]="issue.icon" pack="jira"></nb-icon>
      <a href="/cabinet/crm/project/show/{{issue.issueId}}" class="issue-code">{{ issue.issueId }}</a>
      <app-issue-tag [issue]="issue" *ngIf="issue.tag"></app-issue-tag>
    </td>
    <td>
      <a href="/cabinet/crm/project/show/{{issue.issueId}}" class="issue-name">
        {{ issue.header }}
      </a>
    </td>
    <td class="nw">
      <span [nbTooltip]="translations.estimate" class="hide-for-client-role issue-time">{{ formatDuration(issue.estimate) }} </span>
      <span class="hide-for-client-role" style="color: #aaa; background: none"> / </span>
      <span [nbTooltip]="translations.spent" class="hide-for-client-role issue-time" [class.red]="issue.spent > issue.estimate" [class.green]="issue.spent > 0 && issue.spent < issue.estimate">{{ formatDuration(issue.spent) }} </span>
    </td>
    <td class="nw">
      <span *ngIf="issue.status" class="status">{{ issue.status }}</span>
      <i [nbPopover]="confirm" [nbPopoverContext]="{link: issue}" *ngIf="canDelete()" class="deleted">
        <nb-icon icon="trash-outline"></nb-icon>
      </i>
    </td>
  </tr>
</table>

<div class="hide-for-client-role" *ngIf="store.totalEstimate || store.totalSpent">
  <nb-list class="nb-list stat">
    <nb-list-item *ngIf="store.totalEstimate">
      Оценили - <b> {{ formatDuration(store.totalEstimate) }}</b>
    </nb-list-item>
    <nb-list-item *ngIf="store.totalSpent">
      Затрачено - <b> {{ formatDuration(store.totalSpent) }}</b>
    </nb-list-item>
    <nb-list-item *ngIf="store.totalEstimate && store.totalSpent && store.totalSpent < store.totalEstimate">
      <span class="green">Запас времени</span> - <b> {{ formatDuration(store.totalEstimate - store.totalSpent) }}</b>
    </nb-list-item>
    <nb-list-item *ngIf="store.totalEstimate && store.totalSpent && store.totalSpent > store.totalEstimate">
      <span class="red">Перерасход времени</span> - <b> {{ formatDuration(store.totalSpent - store.totalEstimate) }}</b>
    </nb-list-item>
  </nb-list>
</div>

<ng-template #confirm let-data>
  <nb-card style="padding: 0 20px">
    <nb-card-header>Вы уверены?</nb-card-header>
    <nb-card-body style="margin-top: 20px">
      <button nbButton status="danger" size="small" (click)="deleteLink(data.link)">Удалить</button>&nbsp;&nbsp;
      <button nbButton ghost status="basic" size="small" (click)="closeConfirm()">Отмена</button>
    </nb-card-body>
  </nb-card>
</ng-template>
